import {accountingConstants} from '../constants';

const accountingState = {
  costCenters: [],
  expenseCategories: [],
  listItems: [],
  locations: [],
  numberingFlows: [],
  taxCodes: [],
};

const accountingReducer = (state = accountingState, action) => {
  const {type} = action;
  switch (type) {
    case accountingConstants.GET_COST_CENTERS:
      return {
        ...state,
        costCenters: action.data || []
      }
    case accountingConstants.GET_EXPENSE_CATEGORIES:
      return {
        ...state,
        expenseCategories: action.data || []
      }
    case accountingConstants.GET_LIST_ITEMS:
      return {
        ...state,
        listItems: action.data || []
      }
    case accountingConstants.GET_LOCATIONS:
      return {
        ...state,
        locations: action.data || []
      }
    case accountingConstants.GET_NUMBERING_FLOWS:
      return {
        ...state,
        numberingFlows: action.data || []
      }
    case accountingConstants.GET_TAX_CODES:
      return {
        ...state,
        taxCodes: action.data || []
      }
    default:
      return state;
  }
};

export default accountingReducer;
